import React from "react";
import RegisForm from "../components/RegisForm";

const PageRegis = () => {
  return (
    <div className="bg-gray-100 h-screen">
      <RegisForm />
    </div>
  );
};

export default PageRegis;
